import api from './api';
import type { PickerContext, PickerSuggestResponse } from '../types/picker';

export interface Roster {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
  personas: string[];
}

export const getRosters = async (): Promise<Roster[]> => {
  const response = await api.get('/rosters');
  return response.data;
};

export const getRoster = async (rosterId: string): Promise<Roster> => {
  const response = await api.get(`/rosters/${rosterId}`);
  return response.data;
};

export const createRoster = async (roster: Omit<Roster, 'id' | 'created_at' | 'updated_at'>): Promise<Roster> => {
  const response = await api.post('/rosters', roster);
  return response.data;
};

export const updateRoster = async (rosterId: string, roster: Partial<Roster>): Promise<Roster> => {
  const response = await api.put(`/rosters/${rosterId}`, roster);
  return response.data;
};

export const deleteRoster = async (rosterId: string): Promise<void> => {
  await api.delete(`/rosters/${rosterId}`);
};

export const addPersonaToRoster = async (rosterId: string, personaId: string): Promise<Roster> => {
  const response = await api.post(`/rosters/${rosterId}/personas`, { persona_id: personaId });
  return response.data;
};

export const removePersonaFromRoster = async (rosterId: string, personaId: string): Promise<Roster> => {
  const response = await api.delete(`/rosters/${rosterId}/personas/${personaId}`);
  return response.data;
};

/** SP-A engine seam — LLM-ranked persona suggestions for an assembled
 *  PickerContext. The ✨ oracle's only network call (gesture-gated upstream). */
export const suggestParty = async (ctx: PickerContext): Promise<PickerSuggestResponse> => {
  const response = await api.post('/rosters/suggest', ctx);
  return response.data;
};
